var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45215 14.4001L7.79128 11.061H12.4C13.5045 11.061 14.4 10.1655 14.4 9.06097V3.6001C14.4 2.49553 13.5045 1.6001 12.4 1.6001H3.59998C2.49541 1.6001 1.59998 2.49553 1.59998 3.6001V9.06097C1.59998 10.1655 2.49541 11.061 3.59998 11.061H4.45215V14.4001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReview);
export default __webpack_public_path__ + "static/media/ic-review.d6c89959f8bdd444c4d8ada52def50ba.svg";
export { ForwardRef as ReactComponent };